import { render, staticRenderFns } from "./editFootballRate.vue?vue&type=template&id=8f4be740&scoped=true&"
import script from "./editFootballRate.vue?vue&type=script&lang=js&"
export * from "./editFootballRate.vue?vue&type=script&lang=js&"
import style0 from "./editFootballRate.vue?vue&type=style&index=0&id=8f4be740&prod&lang=css&"
import style1 from "./editFootballRate.vue?vue&type=style&index=1&id=8f4be740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4be740",
  null
  
)

export default component.exports